import { useField } from 'formik'
import { FC } from 'react'
import Select, {
  MenuListComponentProps,
  MenuProps,
  IndicatorContainerProps,
  components
} from 'react-select'
import { SelectInputField } from '../../../models/reusable-components'
import { SelectOption } from '../../../models/form'

import './Inputs.scss'

type TSelectOption = {
  label: string
  value: string | number
}

const ListItems: FC<MenuListComponentProps<SelectOption, false>> = ({
  setValue,
  options,
  selectProps,
  ...props
}) => {
  let isEmpty = true
  return (
    <div className='select-input__menu-list'>
      {options.map((option, key) => {
        const searchValue = selectProps.inputValue ? selectProps.inputValue.toLowerCase() : ''
        const match = option.label.toLowerCase().match(searchValue)
        if (!searchValue || match) {
          if (isEmpty) isEmpty = false
          return (
            <div
              className='select-input__menu-list__option'
              key={option.value}
              onClick={() => setValue(option, 'select-option')}
            >
              {option.label}
            </div>
          )
        }
        if (isEmpty && options.length === key + 1) {
          return (
            <div className='select-input__menu-list__option' key={option.value}>
              No options
            </div>
          )
        }
        return null
      })}
    </div>
  )
}

const Menu: FC<MenuProps<SelectOption, false>> = ({ ...props }) => {
  return (
    <components.Menu {...props}>
      <div className='select-input__menu-wrapper'>{props.children}</div>
    </components.Menu>
  )
}

const Indicator: FC<IndicatorContainerProps<SelectOption, false>> = (props) => {
  return <div className='arrow-indicator'></div>
}

const SelectInput: FC<SelectInputField> = ({
  name,
  options,
  placeholder,
  disabled = false,
  defaultValue,
  setChanges
}) => {
  const [field, meta, { setValue, setTouched }] = useField(name)

  const onChange = (value: any, some: any) => {
    setValue(value.value)
    if(setChanges){
      setChanges(value.value)
    }
  }

  const settings = {
    name,
    options,
    placeholder,
    onChange,
    onBlur: () => {
      setTouched(true, true)
    },
    classNamePrefix: 'select-input',
    isDisabled: disabled ? disabled : !options.length
    // options: options,
    // menuIsOpen: true,
    // isSearchable: isSearchable
  }

  return (
    <div className={`select-input ${meta.touched && meta.error && 'error'}`}>
      <Select
        components={{
          IndicatorSeparator: () => null,
          IndicatorsContainer: Indicator,
          MenuList: ListItems,
          Menu: Menu
        }}
        {...settings}
        value={options ? options.find((option: TSelectOption) => option.value === field.value) : ''}
        defaultValue={defaultValue}
      />
      {meta.touched && meta.error && (
        <div className='validation-error'>
          <div className='validation-error__icon'></div>
          {meta.error}
        </div>
      )}
    </div>
  )
}

export default SelectInput
